@if (!projectHasEmptyField) {
  <div class="quantification__row">
    <div class="quantification__column quantification__column--index-0">
      <div class="quantification__column-rows">
        @for (columnRowIndex of columnRowIndexes; track columnRowIndex) {
          <div class="quantification__column-row">{{ columnRowIndex }}</div>
        }
      </div>
    </div>
    @for (column of columns; track column; let columnIndex = $index) {
      <div
        [class]="'quantification__column quantification__column--index-' + (columnIndex + 1)"
        [class.quantification__column--disabled]="column.disabled"
        >
        <div class="quantification__column-top">
          @if (columnIndex !== 0) {
            <vwui-icon
              class="quantification__column-icon"
              [class.quantification__column-icon--disabled]="column.disabled"
              [iconName]="column.icon"
            ></vwui-icon>
          }
          {{ column.label }}
        </div>
        <div class="quantification__column__values">
          @for (valueLabel of column.valueLabels; track valueLabel; let value = $index) {
            <div class="quantification__column__value"
              (click)="setValue(column, value)"
              [a11yKeyboardClickable]="canEditProjectLibraryItems()"
              [class.quantification__column__value--active]="isActiveValue(column, value)"
              [class.quantification__column__value--disabled]="!canEditProjectLibraryItems()"
              >
              {{ valueLabel }}
            </div>
          }
        </div>
      </div>
    }
  </div>
}

@if (projectHasEmptyField) {
  @if (lastProjectDetailsValue.isPrmTwoProject) {
      <app-explanation>{{ 'COMPONENT.library_item_quantification.error.message_prm_two' | translate }}</app-explanation>
  } @else {
      <app-explanation>{{ 'COMPONENT.library_item_quantification.error.message' | translate : { constructionCostsLabel: lastProjectDetailsValue.projectInfo.constructionCostsLabel } }}</app-explanation>
  }
}
